import axios, { AxiosResponse, CancelToken } from "axios";
import { InvoiceDateResponse, FileSetDetailResponse, InvoiceFileResponse } from "../../models/Invoice";

export const AddTwilioInvoiceFile = async (
	invoiceFile,
	invoiceFileName: string,
	productId: string,
): Promise<AxiosResponse<boolean>> => {
	return await axios.post(`/api/v1/${productId}/Twilio/Invoices/`, { invoiceFile, invoiceFileName });
};

export const GetTwilioInvoiceDetailsListForDate =
	(invoiceDate: string, productId: string) =>
	async (cancelToken?: CancelToken): Promise<AxiosResponse<FileSetDetailResponse[]>> => {
		return await axios.get(`/api/v1/${productId}/Twilio/Invoices/${invoiceDate}`, {
			cancelToken: cancelToken,
		});
	};

export const GetTwilioInvoiceDateResponseList =
	(productId: string) =>
	async (cancelToken?: CancelToken): Promise<AxiosResponse<InvoiceDateResponse[]>> => {
		return await axios.get(`/api/v1/${productId}/Twilio/Invoices`, {
			cancelToken: cancelToken,
		});
	};

export const UpdateTwilioInvoiceHistoryNote =
	(twilioInvoiceHistoryId: string, note: string, productId: string) =>
	async (cancelToken?: CancelToken): Promise<AxiosResponse<boolean>> => {
		return await axios.put(
			`/api/v1/${productId}/Twilio/Invoices/${twilioInvoiceHistoryId}/note`,
			{ note },
			{
				cancelToken: cancelToken,
			},
		);
	};

export const GetTwilioInvoiceFileFromStorage = async (
	twilioInvoiceHistoryId: string,
	fileName: string,
	productId: string,
): Promise<AxiosResponse<InvoiceFileResponse>> => {
	return await axios.get(`/api/v1/${productId}/Twilio/Invoices/${twilioInvoiceHistoryId}/${fileName}`);
};

export const ReprocessTwilioInvoiceFile =
	(twilioInvoiceHistoryId: string, productId: string) =>
	async (cancelToken?: CancelToken): Promise<AxiosResponse<boolean>> => {
		return await axios.put(`/api/v1/${productId}/Twilio/Invoices/${twilioInvoiceHistoryId}/InvoiceFile`, {
			cancelToken: cancelToken,
		});
	};

export const SubmitTwilioAccountingFile =
	(twilioInvoiceHistoryId: string, productId: string) =>
	async (cancelToken?: CancelToken): Promise<AxiosResponse<boolean>> => {
		return await axios.post(`/api/v1/${productId}/Twilio/Invoices/${twilioInvoiceHistoryId}/InvoiceFile`, {
			cancelToken: cancelToken,
		});
	};

export const CheckForNewerTwilioAccountingFileSent =
	(twilioInvoiceHistoryId: string, productId: string) =>
	async (cancelToken?: CancelToken): Promise<AxiosResponse<boolean>> => {
		return await axios.get(`/api/v1/${productId}/Twilio/Invoices/${twilioInvoiceHistoryId}/exists`, {
			cancelToken: cancelToken,
		});
	};

export const GetTwilioInvoiceFile = async (
	twilioInvoiceHistoryId: string,
	file: string,
	fileName: string,
	productId: string,
): Promise<AxiosResponse<File>> => {
	return await axios.post(`/api/v1/${productId}/Twilio/Invoices/${twilioInvoiceHistoryId}/file`, {
		file,
		fileName,
	});
};
